import clearEmoticons from '../functions/clear-emoticons'

// leave the export, even if you don't use it
export default ({ app, router, Vue }) => {
  Vue.prototype.$clearEmoticons = clearEmoticons
}
